

// Dashboard React base styles
import typography from "assets/theme/base/typography";
import { Chart } from "react-chartjs-2";

function configs(labels, datasets) {
  return {
    data: {
      labels,
      datasets: [...datasets],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      
      interaction: {
        intersect: false,
        mode: "index",
      },
      scales: {
        y: {
          grid: {
            drawBorder: false,
            display: true,
            drawOnChartArea: true,
            drawTicks: false,
            borderDash: [5, 5],
          },
          ticks: {
            display: true,
            padding: 10,
            color: "#b2b9bf",
            font: {
              size: 11,
              family: typography.fontFamily,
              style: "normal",
              lineHeight: 2,
            },
          },
        },
        x: {
          grid: {
            drawBorder: false,
            display: false,
            drawOnChartArea: false,
            drawTicks: false,
            borderDash: [5, 5],
          },
          ticks: {
            display: true,
            color: "#b2b9bf",
            padding: 20,
            font: {
              size: 11,
              family: typography.fontFamily,
              style: "normal",
              lineHeight: 2,
            },
          },
        },
      },
      legend: {
        position: "bottom",
        labels: {
          generateLabels: function(chart) {
            return Chart.defaults.global.legend.labels.generateLabels
              .apply(this, [chart]);
          },
          boxWidth: 10,
          usePointStyle: true
        },
        onClick: (e, legendItem) => {
         // let i = legendItem.datasetIndex;
          //let ci = chRef.current.chartInstance;
        }
      }
    },
  };
}

export default configs;
